import { RotateCcw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

const FilterBar = ({ startDate, endDate, onStartDateChange, onEndDateChange, onReset }) => {
  return (
    <div className="flex flex-wrap items-center gap-3">
      <Input type="date" value={startDate} onChange={(e) => onStartDateChange(e.target.value)} className="h-8 w-36 text-xs" />
      <span className="text-xs text-muted-foreground">to</span>
      <Input type="date" value={endDate} onChange={(e) => onEndDateChange(e.target.value)} className="h-8 w-36 text-xs" />

      <Button variant="ghost" size="sm" onClick={onReset} className="h-8 gap-1.5 text-xs text-muted-foreground">
        <RotateCcw className="h-3.5 w-3.5" />
        Reset
      </Button>
    </div>
  );
};

export default FilterBar;
